import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Generator } from "../../../../components/Generator";
import { Grid } from "../../../../components/Grid";
import { selectUserData } from "../../../../components/appData.slice";
import { FormType } from "../../../../components/enums";
//import { useShouldRedirectToHomepage } from "../../../../hooks";
import { Url } from "../../../../router/enums";
//import { selectIsFormValidated } from "../../../../store/HOC/genericUI.selectors";
import { GenericPreload } from "../../../GenericPreload";
import { GenericSummary, SummarySection } from "../../../GenericSummary";
import {
  selectUIData,
  selectSummaryData as selectDamagesSummaryData,
} from "../Damages/damages.selectors";
import { selectSummaryData as selectIncidentSummaryData } from "../Incident/incident.selectors";
import { selectSummaryData as selectIntroductorySummaryData } from "../Introductory/introductory.selectors";
import { selectSummaryData as selectVehicleOwnerSummaryData } from "../VehicleOwner/vehicleOwner.selectors";

import { form } from "./form";

export const Summary = (): JSX.Element => {
  //JIRA LPPLWEBMOB-749
  const userData = useSelector(selectUserData);
  const { login, name, surname } = userData;
  const history = useHistory();
  const referrer = document.referrer;
  const isDirectEntry =
    history.action === "PUSH" && !referrer.includes(window.location.origin);

  if (!isDirectEntry && !login) {
    history.replace(Url.WELCOME);
  }
  //useShouldRedirectToHomepage(selectIsFormValidated(selectUIData));
  const introductoryStoreData = useSelector(selectIntroductorySummaryData);
  const incidentStoreData = useSelector(selectIncidentSummaryData);
  const vehicleOwnerStoreData = useSelector(selectVehicleOwnerSummaryData);
  const vehicleDamagesData = useSelector(selectDamagesSummaryData);

  return (
    <GenericSummary
      currentRoute={Url.OC_VEHICLE_SUMMARY}
      formType={FormType.OC_VEHICLE}
    >
      <SummarySection
        data={introductoryStoreData.perpetrator}
        title="Sprawca"
      />
      <SummarySection
        data={introductoryStoreData.applicant}
        title="Zgłaszający"
      />
      <SummarySection
        data={incidentStoreData.driver}
        title="Dane kierującego"
      />
      <SummarySection
        data={incidentStoreData.circumstances}
        title="Zdarzenie"
      />
      <SummarySection
        data={incidentStoreData.otherPersons}
        title="Inni uczestnicy zdarzenia"
      />
      <SummarySection data={incidentStoreData.witnesses} title="Świadkowie" />
      <SummarySection
        data={vehicleOwnerStoreData.vehicle}
        title="Dane pojazdu poszkodowanego"
      />
      <SummarySection
        data={vehicleOwnerStoreData.owner}
        title="Dane właściciela"
      />
      <SummarySection
        data={vehicleOwnerStoreData.contactPerson}
        title="Osoba kontaktowa"
      />
      <SummarySection
        data={vehicleDamagesData.damages}
        title="Uszkodzenia pojazdu"
      />
      <Helmet>
        <script
          src="../../../DamageRegistrationForm/LPPL_Scripts/ShowSubmitButton.js"
          type="text/javascript"
        />
      </Helmet>
      <Generator
        form={form}
        render={(generatedForm) => (
          <Grid item xs={12}>
            {generatedForm}
          </Grid>
        )}
      />
      <GenericPreload
        form={FormType.OC_VEHICLE}
        redirection={Url.OC_VEHICLE_SENDING}
      />
    </GenericSummary>
  );
};
